import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupA1 } from "../../../../../redux/app/orb3/groups/group-a";
import ORB3TableRows, { renderDataTable } from "../ORB3TableRows";

const ODS_COLUMNS = [
	{ key: "equipment", label: "ODS Equipment" },
	{ key: "substance", label: "Substance" },
	{ key: "quantityKg", label: "Qty (kgs)" },
];

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupA1PreviewProps = OwnProps;

function ORB3GroupA1Preview(props: ORB3GroupA1PreviewProps) {
	const record = props.orb3Record as TORB3GroupA1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemA1 } = record;

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-A", "1.1", renderItemP1()],
					[null, null, "-", renderItemP2()],
					[null, null, "-", `Recharge Type: ${itemA1.rechargeType}`],
					[null, null, "-", renderDataTable(itemA1.items, ODS_COLUMNS)],

					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		const startDTLocal = `${itemA1.startDate}T${itemA1.startTime}:00${record.timeZone}`;
		const utcStart = moment.utc(startDTLocal);
		const stopDTLocal = `${itemA1.stopDate}T${itemA1.stopTime}:00${record.timeZone}`;
		const utcStop = moment.utc(stopDTLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Start Date/Time: {utcStart.format("HH:mm")} hrs UTC on{" "}
					{utcStart.format("DD-MMM-YYYY")} ({itemA1.startTime} SMT on{" "}
					{moment(itemA1.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
				<h4 className="font-medium uppercase">
					Stop Date/Time: {utcStop.format("HH:mm")} hrs UTC on{" "}
					{utcStop.format("DD-MMM-YYYY")} ({itemA1.stopTime} SMT on{" "}
					{moment(itemA1.stopDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
			</>
		);
	}

	function renderItemP2() {
		return (
			<h4 className="font-medium uppercase">
				Start Position: {itemA1.startPosition.latitude} /{" "}
				{itemA1.startPosition.longitude}
				<br />
				Stop Position: {itemA1.stopPosition.latitude} /{" "}
				{itemA1.stopPosition.longitude}
			</h4>
		);
	}

	return renderMain();
}

export default ORB3GroupA1Preview;
